import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from 'react-query';
import 'flowbite';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/ReactToastify.min.css';
import 'react-loading-skeleton/dist/skeleton.css';

import '@rabbit/utils/buildinfo'; // Lets us see information about builds from within them
import { AppContextProviderWrapper } from '@rabbit/app-context';
import { UserProviderWrapper } from '../context/UserContext';
import { ScrollToTop } from '@rabbit/bizproc/react';
import { MixMasterWrapper } from '@rabbit/mixmaster/react';
import { base } from '@rabbit/mixmaster/veils';
import { GenericLexicon } from '@rabbit/mixmaster/core';
import { FBD_HoldingProxy } from '@rabbit/data/types';
import {
  startPeriodicCacheRefresh,
  stopPeriodicCacheRefresh,
} from '@rabbit/search/cherchons';
import AppRoutes from './app_routes';
import PaymentWrapper from '../utils/payment-wrapper';

function App() {
  const queryClient = new QueryClient();

  // Optional: Initialize background index cache refresh for better search performance
  // This prevents cache misses during user searches
  useEffect(() => {
    startPeriodicCacheRefresh([FBD_HoldingProxy], 24 * 60 * 60 * 1000); // Refresh every 24 hours
    console.log('🚀 Algolia index cache refresh initialized');
    return () => stopPeriodicCacheRefresh();
  }, []);

  return (
    <div
      id="app"
      className="bg-canvas flex min-h-[-webkit-fill-available] w-full justify-center md:min-h-screen"
    >
      <QueryClientProvider client={queryClient}>
        <MixMasterWrapper bootstrap={base.core as GenericLexicon}>
          <BrowserRouter>
            <AppContextProviderWrapper>
              <PaymentWrapper>
                <UserProviderWrapper>
                  <ReactQueryDevtools initialIsOpen={false} />
                  <AppRoutes />
                  <ToastContainer />
                </UserProviderWrapper>
              </PaymentWrapper>
            </AppContextProviderWrapper>
            <ScrollToTop />
          </BrowserRouter>
        </MixMasterWrapper>
      </QueryClientProvider>
    </div>
  );
}

export default App;
